"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelRestartAction = void 0;
var tslib_1 = require("tslib");
var interfaces_1 = require("@dp-instant/interfaces");
var inversify_1 = require("inversify");
var core_1 = require("@dp-instant/core");
var SocialFlowAction_1 = require("./SocialFlowAction");
var LevelRestartAction = (function (_super) {
    tslib_1.__extends(LevelRestartAction, _super);
    function LevelRestartAction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.TRACK_EVENT = "level_restart";
        _this.SHOW_AD_INTERVAL = 10;
        return _this;
    }
    LevelRestartAction_1 = LevelRestartAction;
    LevelRestartAction.prototype.needToShowAD = function () {
        return Date.now() - LevelRestartAction_1.LAST_RESTART < this.SHOW_AD_INTERVAL * 1000;
    };
    LevelRestartAction.prototype.launch = function (data) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.social.me.scoreSession = 0;
                        return [4, ((_a = (0, core_1.lazyGet)(interfaces_1.TypesFlow.UI.startScreenAction)) === null || _a === void 0 ? void 0 : _a.run())];
                    case 1:
                        _b.sent();
                        LevelRestartAction_1.LAST_RESTART = Date.now();
                        return [2];
                }
            });
        });
    };
    var LevelRestartAction_1;
    LevelRestartAction.LAST_RESTART = Date.now();
    LevelRestartAction = LevelRestartAction_1 = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], LevelRestartAction);
    return LevelRestartAction;
}(SocialFlowAction_1.SocialFlowAction));
exports.LevelRestartAction = LevelRestartAction;
//# sourceMappingURL=LevelRestartAction.js.map